import eventBus from 'eventBus';
import 'src/lib/plupload-2.1.2/js/plupload.dev.js';

function uploader() {
    this.uploaderList = [];
    this.init = function () {
        this.uploaderList.forEach(function (uper) {
            uper.init();
        });
    };
}

uploader.prototype.config = {
    accessid: 'wKoXc1dyT1cYDBPN',
    accesskey: 'LeXHaVXwKFppzaBywBeA4tVKVNEJ6s',
    host: 'http://zqres.oss-cn-hangzhou.aliyuncs.com',
    g_object_name_type: 'random_name',
    g_ali_dirname: 'http://resimg.iqeq.cn/'
};

uploader.prototype.options = {
    runtimes: 'html5,flash,silverlight,html4',
    multi_selection: false,
    flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
    silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
    url: 'http://oss.aliyuncs.com',
    filters: {
        mime_types: [{
            title: "Image files",
            extensions: "jpg,gif,png"
        }],
        max_file_size: '204800kb',
    }
};

uploader.prototype.generator = function (options) {
    var self = this;
    var opts = Object.assign({}, self.options, options);

    var time = new Date();
    var g_dirname = 'webapires/ol/' + time.getFullYear() + "/" + (time.getMonth() + 1) + "/" + time.getDate() + '/';
    var g_object_name = ''; //文件名
    var g_object_name_type = self.config.g_object_name_type;

    var policyBase64 = Base64.encode(JSON.stringify({
        "expiration": "2050-01-01T12:00:00.000Z", //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
        "conditions": [
            ["content-length-range", 0, 1048576000] // 设置上传文件的大小限制
        ]
    }));

    var signature = Crypto.util.bytesToBase64(Crypto.HMAC(Crypto.SHA1, policyBase64, this.config.accesskey, {
        asBytes: true
    }));

    var uper = new plupload.Uploader({
        runtimes: opts.runtimes,
        flash_swf_url: opts.flash_swf_url,
        silverlight_xap_url: opts.silverlight_xap_url,
        url: opts.url,
        filters: opts.filters,
        browse_button: opts.browse_button,
        container: document.getElementById(opts.container),
        init: {
            // PostInit: function (up, files) {},
            FilesAdded: function (up, files) {
                // plupload.each(files, function (file) {});
                up.start();
            },
            BeforeUpload: function (up, file) {
                var len = len || 32;
                var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
                var maxPos = chars.length;
                var pwd = '';
                for (var i = 0; i < len; i++) {
                    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
                }

                var pos = file.name.lastIndexOf('.'),
                    suffix = '';
                if (pos != -1) {
                    suffix = file.name.substring(pos);
                }
                g_object_name = g_dirname + pwd + suffix;

                up.setOption({
                    'url': self.config.host,
                    'multipart_params': {
                        'key': g_object_name,
                        'policy': policyBase64,
                        'OSSAccessKeyId': self.config.accessid,
                        'success_action_status': '200', //让服务端返回200,不然，默认会返回204
                        'signature': signature
                    }
                });
            },
            UploadProgress: function (up, file) {
                opts.uploadBegin && opts.uploadBegin();
                up.disableBrowse(true);
            },
            FileUploaded: function (up, file, info) {
                if (info.status == 200) {
                    var fileObj = {
                        Name: '',
                        Url: ''
                    };
                    fileObj.Name = file.name;
                    fileObj.Url = self.config.g_ali_dirname + g_object_name;
                    opts.uploaded && opts.uploaded(fileObj);
                    up.disableBrowse(false);
                }
            },
            Error: function (up, err) {
                if (err.code == -600) {
                    eventBus.$message.error('文件大小不符合规范');
                } else if (err.code == -601) {
                    eventBus.$message.error('请上传后缀名为：png , gif , jpg 的图片！');
                } else {
                    eventBus.$message.error(err.message);
                }
            }
        }
    });

    self.uploaderList.push(uper);
    return uper;
};

export default uploader;


// WEBPACK FOOTER //
// ./src/common/js/uploader.js